import type { Router } from 'vue-router';
import { setupPermissionGuard } from './permission-guard';

export function setupRouterGuard(router: Router) {
  setupPermissionGuard(router);
}
